The identifier for the associated position. This corresponds to the `seekPartnerPositionId` field in the GraphQL schema, and should be supplied to the `positionNotPostedReasons` query to retrieve the reason a position has not been posted.
